import React from "react";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";
import { DOCTOR, PRODUCTCODE, PRODUCTNAME } from "../../constants/fetchData";
import SearchableDropdown from "../Layout/SearchableDropdown";
// import SearchableDropdown from "./SearchableDropdown"; // Import the searchable dropdown

const EntryFormContent = ({
  formData,
  handleChange,
  handleSubmit,
  handleCancel,
  heading,
}) => (
  <div className="flex flex-col h-full relative ">
    {/* Header area */}
    <div className="sticky top-0 bg-white z-10 pt-6 w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-text1 text-2xl font-bold">{heading}</h1>
        <div className="hidden sm:block">
          <button
            onClick={handleSubmit}
            className="text-white bg-primary px-4 py-3 rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
      <hr className="mt-5 mb-4" />
    </div>
    <div className="flex-1 overflow-x-hidden pb-24 sm:pb-8">
      <div className="space-y-6">
        {/* Product Details Section */}
        <div className="text-text1 text-xl font-bold">
          <h1>Product Details</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            {/* Product name Dropdown - Now Searchable */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Product name
              </label>
              <SearchableDropdown
                options={PRODUCTNAME}
                value={formData.productName}
                onChange={handleChange}
                name="productName"
                placeholder="Select product"
                searchPlaceholder="Search products..."
                optionKey="name"
                optionLabel="name"
                noOptionsMessage="No products found"
              />
            </div>
            
            {/* Product Code */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Product code
              </label>
              <div className="primary-dropdown mt-1">
                <select
                  name="productCode"
                  className={`rounded px-1 text-sm font-normal  focus:outline-none focus:ring-0 w-full ${
                    formData.productCode === "" ? "text-gray-400" : "text-text1"
                  }`}
                  value={formData.productCode}
                  onChange={handleChange}
                >
                  <option value="">Select code</option>

                  {PRODUCTCODE.map((code) => (
                    <option key={code.id} className="text-text1 uppercase">
                      {code.id}
                    </option>
                  ))}
                </select>
              </div>
              {/* FIXME: //code wil autofill based on product */}
            </div>
            
            {/* Doctor Name Dropdown - Now Searchable */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Doctor name
              </label>
              <SearchableDropdown
                options={DOCTOR}
                value={formData.doctorName}
                onChange={handleChange}
                name="doctorName"
                placeholder="Select doctor"
                searchPlaceholder="Search doctors..."
                optionKey="Full_Name"
                optionLabel="Full_Name"
                noOptionsMessage="No doctors found"
              />
            </div>
            
            {/* Quantity Input */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Quantity
              </label>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                name="quantity"
                placeholder="Eg:5"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.quantity}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, ""); // remove non-digits
                  handleChange({
                    target: {
                      name: e.target.name,
                      value: onlyNums,
                    },
                  });
                }}
              />
            </div>
            
            {/* Status Dropdown */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text">
                Status
              </label>
              <div className="primary-dropdown mt-1">
                <select
                  name="status"
                  className={`rounded px-1 text-sm font-normal  focus:outline-none focus:ring-0 w-full ${
                    formData.status === "" ? "text-gray-400" : "text-text1"
                  }`}
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="ACTIVE" className="text-text1">
                    Active
                  </option>
                  <option value="INACTIVE" className="text-text1">
                    Inactive
                  </option>
                </select>
              </div>
            </div>
          </div>
          <hr className="mt-6 mb-6" />
        </div>

        {/* Patient Details Section */}
        <div className="text-text1 text-xl font-bold">
          <h1>Patient Details</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
            {/* Patient name Input */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Patient name
              </label>
              <input
                type="text"
                name="patientName"
                placeholder="Enter name"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.patientName}
                onChange={handleChange}
              />
            </div>
            {/* Patient Email Address Input */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Patient email address
              </label>
              <input
                type="email"
                name="patientEmail"
                placeholder="Enter email address"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.patientEmail}
                onChange={handleChange}
              />
            </div>
            {/* Patient phone number Input */}
            <div className="flex-1">
              <label className="font-medium text-sm leading-5 text-text2">
                Patient phone no
              </label>
              <input
                type="text"
                name="patientPhone"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Enter phone number"
                className="primary_input text-text2 w-full border rounded-md mt-1 text-sm font-normal"
                value={formData.patientPhone}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, ""); // Remove non-numeric
                  // Limit max length if needed: onlyNums.slice(0, 15)
                  if (onlyNums.length <= 15) {
                    handleChange({
                      target: {
                        name: e.target.name,
                        value: onlyNums,
                      },
                    });
                  }
                }}
              />
            </div>
            {/*  Date */}
            <div className="flex-1">
              <label htmlFor="date" className="primary_label">
                Date
              </label>
              <div className="relative mt-1">
                <div className="absolute inset-y-0 left-0 px-3 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                  <HeroiconsOutlineCalendar className="text-md text-gray-500" />
                </div>
                <div className="pl-10">
                  <input
                    type="date"
                    id="date"
                    name="date"
                    className="w-full custom-dateinput border rounded-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                    value={formData.date}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Fixed button container at the bottom for mobile */}
    <div className="block sm:hidden ">
      <div className=" absolute bottom-0 left-0 right-0 z-10 bg-white opacity-100 border-gray-200  flex justify-end py-2 gap-2">
        <button
          onClick={handleCancel}
          className="text-text1 bg-white border border-gray-300 px-3 py-2 rounded-md"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="text-white bg-primary px-3 py-2 rounded-md"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
);

export default EntryFormContent;